/**
 * Created by daniel.gonzalez on 6/15/15.
 */

'use strict';

/*eslint-disable */

var constants = require('global/mobileAds/mobileAdsConstants');
var base = '142876.measurementapi.com/serve';
var siteId = '90624';
var publisherId = '142876';
var destinationId = '171508';

module.exports = {
    [constants.FULLSCREEN_NAME]: {
        'production': {
            protocol: 'https://',
            base: base,
            ga: {
                utm_medium: 'internal-ad',
                utm_source: '1stdibs-mobile-web',
                utm_campaign: 'full-page-ad',
                utm_content: 'v10-full-screen-on-page-2'
            },
            params: {
                action: 'click',
                publisher_id: publisherId,
                site_id: siteId,
                destination_id: destinationId,
                my_campaign: '1stdibs-mobile-web',
                my_adgroup: 'full-page-ad',
                my_ad: 'v10-full-screen-on-page-2'
            }
        },
        'nonProduction': {
            protocol: 'https://',
            base: base,
            params: {
                action: 'click',
                publisher_id: publisherId,
                site_id: siteId,
                destination_id: destinationId,
                my_campaign: 'tes1',
                my_publisher: 'test1',
                my_ad: 'v10-full-screen-on-page-2',
                my_adgroup: 'test1',
                my_placement: 'test1'
            }
        }
    },
    [constants.MC_APP_BANNER]: {
        'production': {
            //TODO: add google analytics, if desired
            protocol: 'https://',
            base: base,
            params: {
                action: 'click',
                publisher_id: publisherId,
                site_id: siteId,
                my_campaign: '1stdibs-website',
                my_adgroup: 'message-center',
                my_ad: 'respond-with-app'
            }
        },
        'nonProduction': {
            protocol: 'https://',
            base: base,
            params: {
                action: 'click',
                publisher_id: publisherId,
                site_id: siteId,
                my_campaign: '1stdibs-website',
                my_adgroup: 'message-center',
                my_ad: 'respond-with-app'
            }
        }
    }
};

/*eslint-enable */



// WEBPACK FOOTER //
// ./assets/js/global/mobileAds/matConfigs.es.js